import { Checkbox } from '@cian/ui-kit';
import { ChangeEvent, FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectHasVideoFilter } from 'shared/selectors/advancedFilters';

export const HasVideoContainer: FC = () => {
  const { label, value } = useSelector(selectHasVideoFilter);

  const onChange = useFilterChangeCallback();

  const handleChange = useCallback(
    (_: ChangeEvent<HTMLInputElement>, newValue: boolean) => {
      onChange({ action: 'setHasVideo', arguments: [newValue || null] });
    },
    [onChange],
  );

  return <Checkbox label={label} checked={value} onChange={handleChange} />;
};
